import {Paper, ToggleButton as MUIToggleButton, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import dimensions from '@app/styles/dimensions';

export const ToggleButton = ({
  title,
  placement = 'right',
  disabled,
  sx,
  ...props
}) => (
  <Tooltip title={title} placement={placement}>
    <MUIToggleButton
      component={disabled ? 'div' : undefined}
      role="button"
      disabled={disabled}
      size="small"
      sx={[
        {
          '&.MuiToggleButton-root': {
            border: 0,
            margin: theme => theme.spacing(1, 0),
            padding: '7px',
          },
          '&.Mui-selected': {
            color: 'primary.main',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  </Tooltip>
);

ToggleButton.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};

export const SideNav = ({sx, ...props}) => (
  <Paper
    elevation={4}
    sx={[
      {
        width: dimensions.sideNav.width,
        height: '100%',
        position: 'relative',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        zIndex: theme => theme.zIndex.drawer + 1,
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    square
    className="pl-mode-dark"
    {...props}
  />
);

SideNav.propTypes = {
  sx: PropTypes.object,
};

export default SideNav;
